export default __webpack_public_path__ + "static/media/mini-menu.6f64d147.svg";